var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLibraryAdd = function SvgLibraryAdd(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M5.167 10.498a2.688 2.688 0 0 0-1.4.091 2.61 2.61 0 0 0-1.687 1.835 2.644 2.644 0 0 0 3.087 3.246v3.22A2.11 2.11 0 0 0 7.278 21h11.611A2.11 2.11 0 0 0 21 18.889V7.278a2.11 2.11 0 0 0-2.111-2.111h-3.22a2.688 2.688 0 0 0-.091-1.4 2.613 2.613 0 0 0-1.835-1.687 2.644 2.644 0 0 0-3.246 3.087h-3.22a2.11 2.11 0 0 0-2.111 2.111v3.22h.001ZM13 10.5v4M15 12.5h-4"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLibraryAdd);
export default ForwardRef;